import { render, staticRenderFns } from "./MitLostKeyPage.vue?vue&type=template&id=b53dbf4e&scoped=true"
import script from "./MitLostKeyPage.vue?vue&type=script&lang=js"
export * from "./MitLostKeyPage.vue?vue&type=script&lang=js"
import style0 from "./MitLostKeyPage.vue?vue&type=style&index=0&id=b53dbf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53dbf4e",
  null
  
)

export default component.exports